const Footer = () => {
  return (
    <footer className="bg-gray-200 text-black py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-2">Contact Us</h3>
            <p>
              📍 BR Plaza Complex,
              <br />
              Palam Gurgaon Road,
              <br />
              Dundahera, Gurgaon, Haryana - 122016
            </p>
            <p className="mt-2">
              📞 +91 9818790176, +91 9871861728, +91 8383969181
            </p>
            <p>📧 avontoolsupadhyay@gmail.com</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-2">Quick Links</h3>
            <ul className="space-y-1">
              <li>
                <a href="/" className="hover:text-navy">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="hover:text-navy">
                  About
                </a>
              </li>
              <li>
                <a href="/products" className="hover:text-navy">
                  Products
                </a>
              </li>
              <li>
                <a href="/fasteners" className="hover:text-navy">
                  Fasteners
                </a>
              </li>
              <li>
                <a href="/process" className="hover:text-navy">
                  Process
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-navy">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Brochure & GST Info */}
          <div>
            <h3 className="font-semibold mb-2">Company</h3>
            <a
              href="/Avon_Tools_Brochure.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-navy hover:bg-navy-dark text-white px-4 py-2 rounded mb-2"
            >
              Download Brochure
            </a>
            <p className="mt-2">
              GST No: <br /> <span className="font-mono">06AAKPU3829P1ZV</span>
            </p>
          </div>
        </div>

        <div className="text-center text-xs text-gray-600 mt-6 border-t pt-4">
          © {new Date().getFullYear()} Avon Tools. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
